import { useAtom } from 'jotai';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';

import closeIcon from '/public/images/icons/close-icon.png';
import OutsideClickedWrapper from '@/components/common/OutsideClickedWrapper';
import { VERSION } from '@/constants/version';
import { useOnlineUser } from '@/hooks';
import { useLoginModal } from '@/store/login';
import { graduateDownloadModalAtom } from '@/store/v2/graduate';

import * as S from './style';

export default function DownloadCertificateModal() {
  const [modal, setModal] = useAtom(graduateDownloadModalAtom);
  const router = useRouter();
  const userInfo = useOnlineUser();
  const nextUrl = router.asPath.split(`${VERSION}/`)[1];
  const loginModal = useLoginModal();

  const loginButtonHandler = () => {
    if (userInfo) {
      return;
    }
    loginModal.open(nextUrl);
  };

  return (
    modal && (
      <S.ModalBackground>
        <OutsideClickedWrapper setState={setModal}>
          <S.Modal>
            <S.ModalHeader>
              <S.ModalTitleText>안내 메시지</S.ModalTitleText>
              <S.ModalClose>
                <Image
                  src={closeIcon}
                  width={16}
                  height={16}
                  alt='close-icon'
                  onClick={() => setModal(false)}
                />
              </S.ModalClose>
            </S.ModalHeader>
            <S.ModalBody>수료증은 수료생 본인만 저장할 수 있어요.</S.ModalBody>
            <S.ModalButtonWrapper>
              <S.CloseButton onClick={() => setModal(false)}>
                닫기
              </S.CloseButton>
              <S.LoginButton onClick={loginButtonHandler}>로그인</S.LoginButton>
            </S.ModalButtonWrapper>
          </S.Modal>
        </OutsideClickedWrapper>
      </S.ModalBackground>
    )
  );
}
